<script setup lang="ts">
withDefaults(
  defineProps<{ src?: string | null; name?: string | null; size?: number }>(),
  { size: 40 },
);
</script>

<template>
  <div class="avatar" :style="{ width: `${size}px`, height: `${size}px` }">
    <img v-if="src" :src="src" alt="" />
    <span v-else class="initials">{{ name?.[0]?.toUpperCase() ?? '?' }}</span>
  </div>
</template>

<style scoped>
.avatar {
  border-radius: var(--r-full);
  overflow: hidden;
  background: var(--bg-overlay);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.avatar img { width: 100%; height: 100%; object-fit: cover; }
.initials { color: var(--text-secondary); font-weight: 600; }
</style>
